import * as actionTypes from '../actions'

const initialState = {
    listCategoryDetail: [],
    listCategoryDetailPaginate: [],
    loading: true,
    categoryName:""
}

const categoryDetailReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SEARCH_CATEGORIES_DETAIL: {
            return {
                ...state,
                listCategoryDetailPaginate: action.payload,
                listCategoryDetail: action.payload.data
                    ? action.payload.data
                    : action.payload,
                loading: false
            }
        }
        case actionTypes.SHOW_LOADING_CATEGORIES_DETAIL: {
            return {
                ...state,
                loading: true
            }
        }
        case actionTypes.HIDE_LOADING_CATEGORIES_DETAIL: {
            return {
                ...state,
                loading: false
            }
        }
        case actionTypes.CLEAN_CATEGORIES_DETAIL: {
            return initialState
        }
        case actionTypes.SET_CATEGORY_NAME: {
            return {
                ...state,
                categoryName: action.payload
            }
            
        }
        default: {
            return state
        }
    }
}

export default categoryDetailReducer
